import React, { useMemo } from 'react';
import { Stepper, Step, StepLabel } from '@mui/material';
import merchantConfig from '../HelperMerchant/merchantConfig.json';
import { useTranslation } from 'react-i18next';
import { makeStyles } from '~/UIKit/Style';
import { FONT_SIZE_INBETWEEN } from '~/Constants/UI.constants';
import { FITOGRAM_BLUE_TINTED, GRAY_USC } from '~/Constants/Colors.constants';

interface ICreateMerchantTabSelector {
  activeStep?: number;
  isMobile: boolean;
}

const useStyles = makeStyles({
  root: {
    '&.MuiStepper-root': {
      fontSize: FONT_SIZE_INBETWEEN,
      fontWeight: 'bold',
    },
  },
  label: {
    '&.MuiStepLabel-label': {
      fontSize: FONT_SIZE_INBETWEEN,
      marginLeft: 10,
      fontWeight: 'bold',
    },
    '&.Mui-active': {
      color: FITOGRAM_BLUE_TINTED,
    },
    '&.Mui-completed': {
      color: GRAY_USC,
    },
    '&.Mui-disabled': {
      color: GRAY_USC,
    },
  },
  iconContainer: {
    '&.MuiStepLabel-iconContainer': {
      width: 24,
    },
    '&.Mui-active': {
      svg: {
        color: FITOGRAM_BLUE_TINTED,
      },
    },
    '&.Mui-completed': {
      svg: {
        color: GRAY_USC,
      },
    },
    '&.Mui-disabled': {
      svg: {
        color: GRAY_USC,
      },
    },
  },
  stepLabelContainer: {
    '&.MuiStep-root:first-of-type': {
      paddingLeft: 0,
    },
    '&.MuiStep-root:last-of-type': {
      paddingRight: 0,
    },
  },
});
export const CreateMerchantTabSelector = ({ activeStep, isMobile }: ICreateMerchantTabSelector) => {
  const { t } = useTranslation();
  const { classes } = useStyles();
  const steps = useMemo(
    () =>
      merchantConfig?.groups.filter((group) => group.value < 3) as {
        label: string;
        value: number;
      }[],
    [merchantConfig],
  );

  return (
    <Stepper activeStep={activeStep} classes={{ root: classes.root }}>
      {steps.map((group) => {
        const stepProps: { completed?: boolean } = {};
        const showLabel = !(isMobile && group.value !== activeStep);
        return (
          <Step
            key={group.label}
            {...stepProps}
            classes={{ horizontal: classes.stepLabelContainer }}
          >
            <StepLabel classes={{ label: classes.label, iconContainer: classes.iconContainer }}>
              {showLabel ? t(group.label) : ''}
            </StepLabel>
          </Step>
        );
      })}
    </Stepper>
  );
};
